var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2719_90344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6095 21.7238L18.44 16.5543C19.7771 14.819 20.5714 12.6457 20.5714 10.2857C20.5714 4.60571 15.9657 0 10.2857 0C4.60571 0 0 4.60571 0 10.2857C0 15.9657 4.60571 20.5714 10.2857 20.5714C12.6457 20.5714 14.819 19.7771 16.5543 18.44L21.7238 23.6095C21.9848 23.8705 22.3257 24 22.6667 24C23.0076 24 23.3486 23.8705 23.6095 23.6095C24.1295 23.0895 24.1295 22.2438 23.6095 21.7238ZM2.66667 10.2857C2.66667 6.08381 6.08381 2.66667 10.2857 2.66667C14.4876 2.66667 17.9048 6.08381 17.9048 10.2857C17.9048 14.4876 14.4876 17.9048 10.2857 17.9048C6.08381 17.9048 2.66667 14.4876 2.66667 10.2857Z",
    fill: "#02486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6095 21.7238L18.44 16.5543C19.7771 14.819 20.5714 12.6457 20.5714 10.2857C20.5714 4.60571 15.9657 0 10.2857 0C4.60571 0 0 4.60571 0 10.2857C0 15.9657 4.60571 20.5714 10.2857 20.5714C12.6457 20.5714 14.819 19.7771 16.5543 18.44L21.7238 23.6095C21.9848 23.8705 22.3257 24 22.6667 24C23.0076 24 23.3486 23.8705 23.6095 23.6095C24.1295 23.0895 24.1295 22.2438 23.6095 21.7238ZM2.66667 10.2857C2.66667 6.08381 6.08381 2.66667 10.2857 2.66667C14.4876 2.66667 17.9048 6.08381 17.9048 10.2857C17.9048 14.4876 14.4876 17.9048 10.2857 17.9048C6.08381 17.9048 2.66667 14.4876 2.66667 10.2857Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2719_90344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/IconSearch.b71596fe81e0cc9c9f2c14f8f2dbe045.svg";
export { ForwardRef as ReactComponent };